import { initializeApp } from 'firebase/app'
import { browserSessionPersistence, getAuth, GoogleAuthProvider, FacebookAuthProvider, setPersistence } from 'firebase/auth'
import { getDatabase, serverTimestamp } from "firebase/database";
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCzNftrzbNJRm_A5DoA50NlUqEMlCowQA4",
    authDomain: "eclipse-project-342008.firebaseapp.com",
    databaseURL: "https://eclipse-project-342008-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "eclipse-project-342008",
    storageBucket: "eclipse-project-342008.appspot.com",
    messagingSenderId: "226126462179",
    appId: "1:226126462179:web:2ac24469444960083f19d6",
    measurementId: "G-6XCFFN9S7Q"
}

const app = initializeApp(firebaseConfig)
const auth = getAuth()
const database = getDatabase()
const firestore = getFirestore()
const serverTime = serverTimestamp()
const storage = getStorage()
const analytics = getAnalytics()
const google = new GoogleAuthProvider()
const facebook = new FacebookAuthProvider()

setPersistence(auth, browserSessionPersistence)

export {
    app,
    auth,
    database,
    firestore,
    serverTime,
    storage,
    analytics,
    google,
    facebook
}
